import * as React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';

import List from '@mui/material/List';
import TickBoxDish from './TickBoxDish';

import * as ApiCall from '../ApiCall.jsx';


// displays an order with information relevant to kitchen staff
//allows them to set dishes to cooked or uncooked
export default function KitchenOrderCard ({orderInfo}) {

  const orderID = orderInfo.id;
  const tableNumber = orderInfo.tableNumber;
  let dishes = orderInfo.dishes;

  let cooking = [];
  let cooked = [];

  let dishIDs = Object.keys(dishes);
  
  //sort dishes by cooking and cooked
  // push cooked to end of list, uncooked at top of order
  for (let dishID of dishIDs) {
    if (dishes[dishID].status > 1) {
      cooked.push([dishID, dishes[dishID]]);
    }
    else {
      cooking.push([dishID, dishes[dishID]]);
    }
  }

  
  function setCooked(dishID) {
    //api call to set a dish to served in backend
    ApiCall.post("/kitchen/cook_dish", "orderId="+orderInfo.id+"&dishId="+dishID)
    .catch((msg) => { alert("Failed to cook dish: " + msg)});

  }

  function setUnCooked(dishID) {
    //api call to set a dish unserved in backend, will work for all but the last served item
    //as serving that will close the order
    ApiCall.post("/kitchen/uncook_dish", "orderId="+orderInfo.id+"&dishId="+dishID)
    .catch((msg) => { alert("Failed to unCook dish: " + msg)});
  }

  function renderDish(dish, checkedState) {
    const dishID = dish[0];
    const dishDetails = dish[1];
    //when it gets checked or unchecked, cooks and unCooks respectively
    function handleChange(event) {
      if (event.target.checked) {
        setCooked(dishID);
      }
      else {
        setUnCooked(dishID);
      }
    }

    //get ingredients list
    let ings = [];
    dishDetails["ingredients"].map((i) => {
      ings.push(" " + i.name);
    });
    if (ings.length > 0) {
      ings = "Ingredients: " + ings;
    }

    //extras list
    let ext = [];
    for (const [k, value] of Object.entries(dishDetails.extras)) {
      ext.push(" " + value.quantity + "x " + value.name);
    };
    if (ext.length > 0) {
      ext = "Extras: " + ext;
    }

    //special notes
    let note = dishDetails.customerInstructions;
    if (note != "") {
      note = "Instructions: " + note;
    }

    return (
      <Box key={dishID} sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap'}}>
        <TickBoxDish dishInfo={dishDetails} handleChange={handleChange} defaultChecked={checkedState}></TickBoxDish>
        <Typography variant="h6" sx={{fontSize: '16px', pl: 1, flexShrink: 1}} >
          {ings}
        </Typography>
        <Divider></Divider>
      </Box>      
    )
  }

  return ( 
    <Box sx={{ borderRadius: '25px', backgroundColor: '#eeeeee', display: 'flex', flexDirection: 'column', width: 1, p: 3}}>
      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
        <Typography variant="h5" sx={{fontWeight: "bold"}}>
          Table {tableNumber}
        </Typography>
        <Typography variant="h6">
          Order #{orderID.slice(-3)}
        </Typography>
      </Box>
      <Divider></Divider>
      <List sx={{ width: '100%', p: 2}}>
        { 
          //do cooked list first so it always appears on top of list on reload
          cooked.map((dish) => {
            return (renderDish(dish, true));
          })
        }
        {
          cooking.map((dish) => {
            return (renderDish(dish, false));
          })
        }
      </List>
    </Box>
  )
}